<template>
    <div>
        <nav class="nav nav-pills bordered" :class="navClass">
            <a v-for="(cat, i) in cats"
               class="nav-link"
               :class="{active: selectedCats.includes(i)}"
               href="#"
               @click.prevent="toggleCat(i)">{{cat}}</a>
        </nav>
    </div>
</template>

<script>
    export default {
        name: "content-type-selector",
        props: ['types', 'navClass'],
        data(){
            return {
                cats: ['Straight', 'Shemale', 'Gay'],
                selectedCats: [0],
            }
        },
        mounted(){
            this.$api.getUserInfo()
                .then((info)=>{
                    this.selectedCats = info.data.user.contentTypes
                })
        },
        methods:{
            toggleCat(catIdx){
                if(this.selectedCats.includes(catIdx)){
                    const idx = this.selectedCats.indexOf(catIdx);
                    this.selectedCats.splice(idx, 1);
                } else {
                    this.selectedCats.push(catIdx);
                }

                this.$api.changeUserContentTypes(this.selectedCats)
                    .then((res)=>{
                        this.$store.dispatch('user/init', res.data.token);
                    });
            },
        }

    }
</script>

<style scoped lang="sass">
    .bordered
        a
            margin-right: .8em
            border: 1px solid

    .justify-content-center
      .bordered
        a
          margin: .4em
</style>



// WEBPACK FOOTER //
// src/components/ui/buttons/ContentTypeSelector.vue